import {GET_LIST} from "../fetchApi/types";
import {changeAfterDeleteDataValidity, changeAfterSaveDataValidity} from "../actions/RealtimeActions";
import {Dispatch} from "redux";
import {DataProvider} from "../fetchApi/tsTypes";
import {QueryResult} from '../components/material-table/types';
import {NotificationManager} from 'react-notifications';

interface ParamsShape {
    order?: Array<string>;
    limit: number;
    filter: Record<string, any>;
    include?: string | Array<string> | Array<Record<string, any>>;
    skip: number;
    page: number;
    fields?: Record<string, any>;
}

export const fetchListData = (
    dataProvider: DataProvider,
    dispatch: Dispatch,
    params: ParamsShape,
    resource: string
): Promise<QueryResult<any>> => {
    return new Promise(resolve => {
        const {order, limit, filter, include, skip, fields, page} = params;

        return dataProvider(GET_LIST, resource, {
            order,
            limit,
            filter,
            include,
            skip,
            fields
        })
            .then(answer => {
                const {data} = answer;
                resolve({
                    page,
                    data,
                    totalCount: answer.total,
                });
            })
            .catch((e: Error) => {
                NotificationManager.error(e.message, 'Error acquired', 1500);
            })
            .finally(() => {
                // TODO: rework
                const actionSave = changeAfterSaveDataValidity({resource, payload: []});
                const actionDelete = changeAfterDeleteDataValidity({resource, payload: true});
                dispatch(actionSave);
                dispatch(actionDelete);
            });
    });
};
